import React, { useEffect, useState } from 'react';
import api from './api';
import { PROJECT_STATUS_BADGE_CLASS, PROJECT_STATUS_LABELS, projectCode, formatDate } from './helpers';

function Reports() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/projects')
      .then((res) => setProjects(res.data))
      .catch(() => setError('Impossible de charger les rapports.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Chargement...</p>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="fade-in">
      <div className="page-header-row">
        <p style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
          Rapport d'avancement — un état par projet, mis à jour en continu.
        </p>
        <button className="btn btn-primary" onClick={() => window.print()}>Exporter en PDF</button>
      </div>

      {projects.map((p) => (
        <div key={p.id} className="report-card">
          <div className="report-card-top">
            <div>
              <span className="project-ref">{projectCode(p.id)}</span>{' '}
              <span className={`badge ${PROJECT_STATUS_BADGE_CLASS[p.status] || 'badge-active'}`}>{PROJECT_STATUS_LABELS[p.status] || p.status}</span>
              <div className="project-title">{p.name}</div>
              <div className="project-meta">{p.description}</div>
            </div>
            <div>
              <div className="report-pct">{p.progress_percent}%</div>
              <div className="report-pct-label">avancement</div>
            </div>
          </div>

          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${p.progress_percent}%` }} />
          </div>

          <div className="report-footer">
            <div>
              <div className="detail-stat-label">Échéance</div>
              <div>{formatDate(p.end_date)}</div>
            </div>
            <div>
              <div className="detail-stat-label">Budget dépensé</div>
              <div>{((p.budget_spent / p.budget_allocated) * 100).toFixed(0)}%</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Reports;
